import React, { useEffect, useMemo } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';

interface Props {
  display_url: string;
  upload_percent: number | undefined;
  completed: boolean;
  type: string;
}

export default function MediaUploadDisplay({ display_url, upload_percent, completed, type }: Props) {
  return (
    <div
      style={{
        width: '3.75rem',
        height: '3.75rem',
        cursor: 'pointer',
        margin: '.25rem',
        border: '1px',
        borderColor: 'grey',
        borderRadius: '5px',
        padding: '.1rem',
        borderStyle: 'solid',
        position: 'relative',
      }}
    >
      {type.includes('image') && (
        <img
          style={{
            width: '3.75rem',
            height: '3.75rem',
            cursor: 'pointer',
            objectFit: 'contain',
            position: 'relative',
          }}
          alt="preview image"
          src={display_url}
        />
      )}
      {type.includes('video') && (
        <video
          style={{
            width: '3.75rem',
            height: '3.75rem',
            cursor: 'pointer',
            position: 'relative',
          }}
          src={display_url}
        />
      )}
      {upload_percent && !completed && (
        <div
          style={{
            width: '1.75rem',
            height: '1.75rem',
            position: 'absolute',
            left: '1rem',
            top: '1rem',
            display: '',
          }}
        >
          <CircularProgressbar value={upload_percent} strokeWidth={15} />
        </div>
      )}
    </div>
  );
}
